
export { HorizontalProductCardSkeleton } from "/codebuild/output/src1091960197/src/packages/shared-components/src/components/ProductCard/index.ts"
export { VerticalProductCardSkeleton } from "/codebuild/output/src1091960197/src/packages/shared-components/src/components/ProductCard/index.ts"